import React from 'react'
import "../../Css/Hero.css";
import bg from "../../assets/hero_section_bg_enterprise_.webp";
import front from "../../assets/hero_section_front_enterprise_.webp";

const HeroSectionEnterPrise = () => {
  return (
    <section className="relative flex flex-col items-center justify-center overflow-hidden min-h-screen">

      <div className="absolute inset-0 -z-10">
        <img
          src={bg}
          alt="glare"
          className="h-full w-full object-cover"
        />
        <div className="image-overlay absolute inset-0"></div>
      </div>

      <div className="w-full px-5 sm:px-4 pt-[120px] xl:mt-52">
        <div className="flex justify-center">
          <div className="w-full md:w-[100%] lg:w-[82%] xl:w-[70%]">
            <div
              className="rounded-2xl shadow md:pr-1 md:pl-2"
              style={{
                background: "rgba(237, 241, 249, 0.7)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
              }}
            >
              <div className="grid grid-cols-1 items-center px-5 xl:px-10 py-5 gap-5 md:grid-cols-12">

                {/* Left Side */}
                <div className="col-span-12 p-2 sm:p-3 md:col-span-7 md:p-4">
                  <div className="-mx-2 sm:-mx-3 md:-mx-6 -mt-2 sm:-mt-3 md:-mt-6 mb-4 lg:mt-3 overflow-hidden rounded-t-2xl">
                    <img
                      src={front}
                      alt="Delivery Van"
                      className="h-[160px] w-full object-cover sm:h-[190px] md:h-[200px] lg:h-[270px]"
                    />
                  </div>
                  <h2 className="text-center text-[22px] leading-6 lg:leading-8 sm:text-[24px] md:text-left lg:text-[28px] text-[#212529] font-sf">
                    Effortless delivery infrastructure for growing businesses
                  </h2>
                  <p className="mt-2 text-center text-[16px] font-light text-gray-700 sm:text-base lg:text-[18px] md:text-left">
                    From warehouse to doorstep, Packky manages dispatch, routing,
                    and tracking without the need for your own fleet.
                  </p>
                </div>

                {/* Right Side - Form */}
                <div className="col-span-12 flex justify-center md:pl-5 :col-span-5 md:col-span-5">
                  <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow md:max-w-none lg:p-7">
                    <h5 className="mb-4 text-center text-[18px] font-semibold sm:text-[22px] text-[#212529]">
                      Fill Out For More Details
                    </h5>
                    <form className="space-y-3">
                      <input
                        type="text"
                        placeholder="Enter your Name*"
                        required
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                      />
                      <input
                        type="text"
                        placeholder="Enter your Company Name*"
                        required
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                      />
                      <input
                        type="text"
                        placeholder="Enter your Phone Number*"
                        required
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                      />
                      <input
                        type="email"
                        placeholder="Enter your Email ID*"
                        required
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#f39731] sm:text-base"
                      />
                      <button
                        type="submit"
                        className="w-full rounded-md bg-[#f39731] py-2 font-semibold text-white transition hover:opacity-90"
                      >
                        Get in Touch
                      </button>
                    </form>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionEnterPrise;